module.exports = __webpack_public_path__ + "ef957703c11c5472df66c86dc26d506e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Lato-Bold.woff
// module id = 1483
// module chunks = 0